import { DsmGrid } from "@dsm-dcs/design-system-react";
import { Dispatch, FC, SetStateAction, useEffect, useRef } from "react";
import ReactHookDsmInput from "../../../../../modules/Helpers/ReactHookDsmInput2";
import { useFormContext } from "react-hook-form";
import { BeefIntervention } from "../../../../models/Intervention/BeefIntervention";
import { processAndStageStylesV2 } from "../../../../../../_metronic/layout";
import { CSSClassesList } from "../../../../helpers/helperTypes";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import ReactHookDsmRadioGroup, { RadioGroupOption } from "../../../../../modules/Helpers/ReactHookDsmRadioGroup";
import { BeefInputGrowing } from "../../../../models/Baseline/BeefBaseline";
import { FormType } from "../../common";
import EditModeButtons from "../../../helpers/EditModeButtons";
import { cloneDeep } from "lodash";
import RowTextFieldWithMetrics from "../../../../../modules/Farms/Intervention/RowControlledTextFieldWithMetrics2";
import { Spacer } from "../../../helpers/Spacer";
import { isFieldFilled } from "../CommonDataParts/InterventionGenericInfoDialog";

interface BeefInputBatchGrowingRepetitionComponentProps {
  formType: FormType;
  fieldItemPrefix: string;
  defaultStageData: BeefInputGrowing;
  isRepetitionEdit: boolean;
  setIsRepetitionEdit: Dispatch<SetStateAction<boolean>>;
  repetitionCancelHandler: (isInnerCancel?: boolean) => void;
}

const BeefInputBatchGrowingRepetitionComponent: FC<BeefInputBatchGrowingRepetitionComponentProps> = ({
  formType,
  fieldItemPrefix,
  defaultStageData,
  isRepetitionEdit,
  setIsRepetitionEdit,
  repetitionCancelHandler,
}) => {
  const intl = useIntl();
  const classes: CSSClassesList = processAndStageStylesV2();
  const fc = useFormContext<BeefIntervention>();

  const isStageRepeatedValue = defaultStageData.isStageRepeated.toString();
  const isStageRepeated = isStageRepeatedValue === "Yes";

  const isStageRepeatedOptions: RadioGroupOption[] = [
    {
      value: "Yes",
      label: intl.formatMessage({
        id: "GENERAL.YES",
      }),
    },
    {
      value: "No",
      label: intl.formatMessage({
        id: "GENERAL.NO",
      }),
    },
  ];

  const renderNumberOfRepetitions = () => {
    if (!isStageRepeated)
      return;

    return (
      <>
        <Spacer />
        <DsmGrid className={classes.dsmGridTwoColumnNoRowSpacing}>
          {!isRepetitionEdit ? (
            <>
              {isFieldFilled(fc.getValues(`${fieldItemPrefix}.numberOfRepetitions`)) ? (
                <>
                  <RowTextFieldWithMetrics
                    name={`${fieldItemPrefix}.numberOfRepetitions`}
                    label={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.NUMBER_OF_REPETITIONS" })}
                    tooltip={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.NUMBER_OF_REPETITIONS.TOOLTIP" })}
                    type="number"
                    metricUnit=""
                    baseline={defaultStageData.numberOfRepetitions}
                    displayTypeSelect={false}
                    disabled
                  />
                  <Spacer />
                </>
              ) : (
                <ReactHookDsmInput
                  name={`${fieldItemPrefix}.originalNumberOfRepetitions`}
                  label={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.NUMBER_OF_REPETITIONS" })}
                  tooltip={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.NUMBER_OF_REPETITIONS.TOOLTIP" })}
                  adornment={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.NUMBER_OF_REPETITIONS.ADORNMENT" })}
                  defaultValue={defaultStageData.numberOfRepetitions}
                  type="number"
                  disabled
                />
              )}
            </>
          ) : (
            <RowTextFieldWithMetrics
              name={`${fieldItemPrefix}.numberOfRepetitions`}
              label={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.NUMBER_OF_REPETITIONS" })}
              tooltip={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.NUMBER_OF_REPETITIONS.TOOLTIP" })}
              type="number"
              metricUnit=""
              baseline={defaultStageData.numberOfRepetitions}
              disabled={false}
            />
          )}
        </DsmGrid>
      </>
    )
  }

  return (
    <DsmGrid className={classes.dsmGridOneColumnWithBorder}>
      <DsmGrid className={classes.dsmGridTwoColumnNoRowSpacing}>
        <ReactHookDsmRadioGroup
          name={`${fieldItemPrefix}.isStageRepeated`}
          label={`${intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.IS_STAGE_REPEATED" })}`}
          defaultValue={isStageRepeatedValue}
          options={isStageRepeatedOptions}
          disabled
        />
      </DsmGrid>

      {renderNumberOfRepetitions()}

      {(formType !== FormType.View && isStageRepeated) &&
        <EditModeButtons
          isEditing={isRepetitionEdit}
          onEdit={() => setIsRepetitionEdit(true)}
          onCancel={repetitionCancelHandler}
        />}
    </DsmGrid>
  )
}

export default BeefInputBatchGrowingRepetitionComponent;
